var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item',[_c('q-item-section',[_c('q-item-label',[_vm._v("Core Temperature")])],1),_c('q-item-section',{attrs:{"side":""}},[_c('q-badge',{attrs:{"color":"green-3","label":"14 °C"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }